import { render, staticRenderFns } from "./CategoricalData.vue?vue&type=template&id=0fd1e00c&scoped=true"
import script from "./CategoricalData.vue?vue&type=script&lang=js"
export * from "./CategoricalData.vue?vue&type=script&lang=js"
import style0 from "./CategoricalData.vue?vue&type=style&index=0&id=0fd1e00c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1e00c",
  null
  
)

export default component.exports